/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';

import Color from '@tool/color';
import { RadioCheck, UnRadioCheck } from '@/styled/icon';
import '../scss/common.scss';
import moQuestion, { changeFour, changeQuestion } from '../store';
import {
  ActiveLinearProgress,
  BorderLinearProgress,
  DefaultLinearProgress,
  NextButton,
  PrevButton,
} from '@/styled/button';
import { submitQuestion } from '@/styled/common';
import { observer } from 'mobx-react';
import { round } from 'lodash';

const FourQuestion = (props: any) => {
  const { fourAnswer, prevtime } = moQuestion;
  const [twoList, setTwoList] = useState<any>([]);
  const [type, setType] = useState('question');
  const oneList = [
    '无',
    '2个等级',
    '3个等级',
    '4个等级',
    '5个等级',
    '6个等级',
    '7个等级',
    '更多',
    '暂无法提供',
  ];

  const onSave = async () => {
    const result: any = await submitQuestion(
      '员工绩效分为几个等级',
      [fourAnswer],
      prevtime,
    );
    const arr1: any = [];
    oneList.forEach((res: any) => {
      if (result.some((ele: any) => ele.answer === res)) {
        result.forEach((ele: any) => {
          if (res === ele.answer) {
            arr1.push(round(ele.ratio * 100, 1));
          }
        });
      } else {
        arr1.push(0);
      }
    });
    setTwoList(arr1);
    setType('answer');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className='allQuestion'>
      {type === 'question' ? (
        <section className='allContent'>
          <h2>一、调薪率</h2>
          <h3>1.4 员工绩效分为几个等级</h3>
          {oneList?.map((res: any) => {
            return (
              <p
                className='checkList'
                key={res}
                onClick={() => {
                  changeFour(res);
                }}>
                {fourAnswer !== res ? (
                  <UnRadioCheck color={Color.cf} />
                ) : (
                  <RadioCheck color={Color.primary} />
                )}
                <span className={fourAnswer === res ? 'active' : ''}>
                  {res}
                </span>
              </p>
            );
          })}
        </section>
      ) : (
        <section className='allContent'>
          <h2>一、调薪率</h2>
          <h3>1.4 员工绩效等级统计结果</h3>
          {oneList?.map((res: any, r: any) => {
            return (
              <section key={res} className='items'>
                <section
                  className={
                    fourAnswer === res ? 'proActive' : 'process'
                  }>
                  <b>{res}</b>
                  <label>{`${twoList[r]}%`}</label>
                </section>
                {fourAnswer !== res ? (
                  <DefaultLinearProgress
                    variant="determinate"
                    value={twoList[r]}/>
                ) : (
                  <ActiveLinearProgress
                    variant="determinate"
                    value={twoList[r]}/>
                )}
              </section>
            );
          })}
        </section>
      )}
      <section className='btnGroup'>
        <section className='numProgress'>
          <p className='num'>
            <span>4</span> / 15
          </p>
          <BorderLinearProgress variant="determinate" value={(4 / 15) * 100} />
        </section>
        <PrevButton
          onClick={() => {
            changeQuestion(3);
          }}>
          上一题
        </PrevButton>
        {type === 'question' ? (
          <PrevButton
            onClick={() => {
              changeQuestion(5);
            }}>
            跳过此题
          </PrevButton>
        ) : (
          <PrevButton
            onClick={() => {
              setType('question');
            }}>
            重新填写
          </PrevButton>
        )}
        {type === 'question' ? (
          <NextButton onClick={onSave} disabled={!fourAnswer}>
            保存查看结果
          </NextButton>
        ) : (
          <NextButton
            onClick={() => {
              changeQuestion(5);
            }}>
            下一题
          </NextButton>
        )}
      </section>
    </section>
  );
};

export default observer(FourQuestion);
